
import { Box } from "@mui/material";

const DonorLabelPreview = ({ donor }) => {
  if (!donor) return null;

  const lines = [];


  if (donor.donorId) lines.push(`#${donor.donorId}`);
  
 
  if (donor.tamilMonth || donor.nachathiram)
    lines.push(`${donor.tamilMonth || ""} ${donor.nachathiram || ""}`.trim());
  

  lines.push(
    `${donor.salutation || ""} ${donor.initial || ""} ${donor.firstName || ""} ${donor.lastName || ""}`.trim()
  );
  
 
  if (donor.address) lines.push(donor.address);
  if (donor.address1) lines.push(donor.address1);
  if (donor.address2) lines.push(donor.address2);
  

  if (donor.city || donor.pincode)
    lines.push(`${donor.city || ""} ${donor.pincode || ""}`.trim());
  
 
  let mobile1 = donor.mobile1 ? String(donor.mobile1).trim() : "";
  let mobile2 = donor.mobile2 ? String(donor.mobile2).trim() : "";
  // const countryCode = donor.countryCode || "91";
  
  // Strip country code prefix safely - only remove the actual country code, not part of the number
  // const stripCountryCode = (num) => {
  //   if (!num) return "";
  //   if (num.startsWith(`+${countryCode}`)) {
  //     return num.slice((`+${countryCode}`).length).trim();
  //   } else if (num.startsWith(countryCode)) {
  //     return num.slice(countryCode.length).trim();
  //   }
  //   return num;
  // };
//   const stripCountryCode = (num) => {
//   if (!num) return "";

//   let cleaned = num.replace(/\s+/g, "").trim();

//   // Remove +91
//   if (cleaned.startsWith(`+${countryCode}`)) {
//     return cleaned.substring(countryCode.length + 1);
//   }

//   // Remove 91 only if number length > 10
//   if (cleaned.startsWith(countryCode) && cleaned.length > 10) {
//     return cleaned.substring(countryCode.length);
//   }

//   return cleaned;
// };
  
//   mobile1 = stripCountryCode(mobile1);
//   mobile2 = stripCountryCode(mobile2);


  const hasMobile1 = mobile1 && mobile1.replace(/\D/g, '').length > 3;
  const hasMobile2 = mobile2 && mobile2.replace(/\D/g, '').length > 3;
  
  if (hasMobile1 || hasMobile2) {
    const mobileText = [];
    if (hasMobile1) mobileText.push(mobile1);
    if (hasMobile2) mobileText.push(mobile2);
    // Format: "Mob: XXXXXXXXXX YYYYYYYYYY" (only last 10 digits, space separator)
    lines.push(`Mob: ${mobileText.join(",")}`);
  }

  const addressLines = lines.slice(3).filter(Boolean).length;

  const isLarge = addressLines > 4;

  const styleSmall = {
    fontSize: "13px",
    width: "240px",
    minHeight: "130px",
    lineHeight: 1.4,
    padding: 2.5,
  };

  const styleLarge = {
    fontSize: "14px",
    width: "280px",
    minHeight: "160px",
    lineHeight: 1.5,
    padding: 3,
  };

  const appliedStyle = isLarge ? styleLarge : styleSmall;

  return (
    <Box
      sx={{
        border: "1px solid #bdbdbd",
        borderRadius: 1,
        bgcolor: "#fff",
        fontFamily: "'Helvetica', 'Arial', sans-serif",
        whiteSpace: "pre-wrap",
        color: "#000",
        boxShadow: 2,
        textAlign: "left",
        overflowWrap: "break-word",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...appliedStyle,
      }}
    >
      <Box sx={{ width: "100%", textAlign: "left" }}>{lines.join("\n")}</Box>
    </Box>
  );
};

export default DonorLabelPreview;